import { render, staticRenderFns } from "./AdRevenueQuery.vue?vue&type=template&id=debf8a8a&scoped=true"
import script from "./AdRevenueQuery.vue?vue&type=script&lang=js"
export * from "./AdRevenueQuery.vue?vue&type=script&lang=js"
import style0 from "./AdRevenueQuery.vue?vue&type=style&index=0&id=debf8a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debf8a8a",
  null
  
)

export default component.exports